import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { fetchOrderItemFlightDetails } from 'actions/OrderActions'
import { fetchCruiseOfferSnapshot } from 'actions/CruiseActions'

/** Load missing itinerary data before benefit eligibility decides whether to mount a card. */
function useLoyaltyOrderItineraries(orders: ReadonlyArray<App.Order>, enabled: boolean) {
  const dispatch = useAppDispatch()
  const flightDetails = useAppSelector(state => state.orders.flightDetails)
  const cruiseSnapshots = useAppSelector(state => state.cruise.cruiseOfferSnapshot)
  const cruiseLoading = useAppSelector(state => state.cruise.cruiseOfferSnapshotLoading)
  const cruiseErrors = useAppSelector(state => state.cruise.cruiseOfferSnapshotError)

  useEffect(() => {
    if (!enabled) return

    orders.forEach(order => {
      order.flightItems.forEach(item => {
        if (!flightDetails[item.id]) {
          dispatch(fetchOrderItemFlightDetails(order.id, item.id))
        }
      })
      order.cruiseItems.forEach(item => {
        if (!cruiseSnapshots[item.bookingId] && !cruiseLoading[item.bookingId] && !cruiseErrors[item.bookingId]) {
          dispatch(fetchCruiseOfferSnapshot(item.bookingId))
        }
      })
    })
  }, [dispatch, orders, enabled, flightDetails, cruiseSnapshots, cruiseLoading, cruiseErrors])
}

export default useLoyaltyOrderItineraries
